import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
const activeRowModal: any = ref({ data: null });
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import i18n from '@/localization/i18n';
const { t } = i18n.global;

function getAccessControlById(value: number): string | undefined {
    const store = useStore()
    const accessControlOptions = store.state.general.enums?.['GlobalAccessControl'] || []
    const item = accessControlOptions.find((x: any) => x.value === value)
    return item?.label
}

function getFolderNameById(value: number): string | undefined {
    const folderMaps = store.state.general.folderMaps as { label: string; value: number }[];
    const folder = folderMaps.find((item: any) => item.value === value);
    return folder?.label;
}
function getAccessControlStyle(value: number) {
    const label = (getAccessControlById(value) || '').toLowerCase();

    let color = '#1677FF'; 
    let bg = '#1677FF33';

    if (label.includes('deny') || label.includes('block')) {
        color = '#E04C4D';
        bg = '#DE323229';
    } else if (label.includes('read/write')) {
        color = '#0C7EC5';
        bg = '#01AAF342';
    } else if (label.includes('read only')) {
        color = '#3461D3';
        bg = '#D3E0FF';
    }

    return { color, bg };
}

const data = {
    filter: {
        title: "fileAccessfilter",
        pageName: "fileAccessfilter",
        genre: "fileAccessPageFilter",
        ignoreSaveFilter: true,
        noDateSelect: true,
        hideFilter: false,
        //quickSearch: "fullTextSearch",
        filters: [
        ],
    },
    header: {
        navigation: [

        ],
        buttonPosition: "pr-4 justify-content-between",
        buttons: [

        ],
    },
    component: {
        type: "ag-table",
        options: {
            columns: [
                {
                    label: () => t('path').toUpperCase(),
                    field: "fileName",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        const truncateMiddle = (input: string, max = 50): string => {
                            const str = (input || "").toString();
                            if (str.length <= max) return str;
                            return str.slice(0, max) + "...";
                        };
                        const path = row.fileName ?? "";
                        const hasFolderMap = row.folderMapId !== null && row.folderMapId !== undefined;
                        const folderMap = hasFolderMap ? (getFolderNameById(row.folderMapId) ?? "") : "";
                        const fullPath = !hasFolderMap && row.isFolderMapIdAny
                            ? `*\\${path}`
                            : (folderMap && path
                                ? `${folderMap}\\${path}`
                                : `${folderMap}${path}`);
                        const truncatedFullPath = truncateMiddle(fullPath, 50);
                        const lastSegment = (path || '').split('\\').pop() || '';
                        const lowerSeg = lastSegment.toLowerCase();
                        const hasExtension = /\.[a-z0-9]{1,8}$/.test(lowerSeg);
                        let iconClass = 'ag-icon_noun_folder';
                        if (hasExtension) {
                            if (lowerSeg.endsWith('.dll')) {
                                iconClass = 'ag-icon_dll';
                            } else if (lowerSeg.endsWith('.exe')) {
                                iconClass = 'ag-icon_exe';
                            } else {
                                iconClass = 'ag-icon_noun_file';
                            }
                        }
                        const leadingIcon = `<i class='ag-icon ${iconClass}' style='width:16px;height:19px;margin-right:8px;'></i>`;

                        let html = "<div class='d-flex flex-column align-items-start'>";
                        html += `<div class='d-flex align-items-center'>${leadingIcon}<span style='color: #01172F; font-weight: bold; ' >` + truncatedFullPath + "</span></div>"
                        if (row.enabled === false) {
                            html += "<div class='d-flex align-items-center' style='margin-top:10px;margin-left:24px'><i class='ag-icon ag-icon_warning_filled' style='font-size:0.8em !important;'></i><span style='font-size:0.7em; color:#636363; margin-left:6px;'>This rule is disabled and will not be published</span></div>";
                        }
                        html += "</div>";
                        return html;
                    },
                    width: "50%",
                },
                {
                    label: () => t('accessControl').toUpperCase(),
                    field: "accessControl",
                    display: (row: any) => {
                        const accessControl = row.accessControl ? getAccessControlById(row.accessControl) : "";
                        const styles = row.accessControl != null ? getAccessControlStyle(row.accessControl) : { color: '#1677FF', bg: '#1677FF33' };
                        return `
                            <span style='margin-left:8px;background:${styles.bg};color:${styles.color};border-radius:16px;padding:2px 8px;font-weight:700;font-size:12px;display:inline-flex;align-items:center;'>
                                ${accessControl}
                            </span>`;
                        
                    },
                    sortable: true,
                    jsSort: true,
                    width: "30%",
                },
                {
                    label: () => t('action').toUpperCase(),
                    field: "commands",
                    justify: 'justify-content-center',
                    style: { justifyItems: 'center' },
                    components: [
                        {
                            component: "appGroupTableEditComponent",
                        },
                        {
                            component: "copyAction",
                            class: "mr-2 ml-2",
                        },
                        {
                            component: "appGroupDeleteComponent",
                        },
                    ],
                    width: "120px",

                },
            ],
            rows: [],
            total: 0,
            sortable: {
                order: "",
                sort: "asc",
            },
            page: 0,
            pageSize: 0,
            isLoading: true,
            showPagination: false,
            dateFilter: false,
            zebra: true,
            separateBorders: true,
            editOnRowClick: true,
            fetchTable: (options: any) => {
                store.dispatch(GeneralActionTypes.GET_GLOBAL_POLICY_FILE_ACCESS, {
                    options: options,
                    filters: {}
                });
            }
        },
    },

};

export default data;
